// removed by extract-text-webpack-plugin
module.exports = {"component":"sx3vdj2gnxqh3unkun9c9k42n221j6p32r9k1scyuagnq8d6mxt2ur5app6zsc6hjvj8ue9arb4fsp3svc2reyzt2b1f6anes39gph-styles-module-component","userLabel":"_3w7fjcx1mgv941zn33uvavm5h2wkmjsss8uk6j7g23hvnb23r5vm7xaxhw3ykstkvusjcxw8sk54ft6pe84ex27zyhw4ym48vkwrjk-styles-module-userLabel","userSelect":"j123hugyk3xkzt779ffkr8tjb1eku289frd4d1m5ah3bxgv9ywvz2scx1nffwmssaqzhzmrwnrw8rfuz2z8ve3jdx5fd6b5ehr7y92-styles-module-userSelect"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/UserChange/styles.module.sass
// module id = 577
// module chunks = 0